import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Wrapper, Container, Header } from '../../components';
import CurvedContainer from '../../components/CurvedContainer';
import { useActions } from 'hooks/useActions';
import { Images } from 'util/images';
import * as actions from './actions';
import TooltipContainer from '../../components/Tooltip';
import Filter from '../../components/FilterSidebar';
import {
  AchievementGrid,
  AchievementContainer,
  AchievementIcon,
  AchievementLabel,
  ContentContainer,
  LeftContainer,
  RightContainer,
} from '../AchievementsPage/styles';
import XPLevel from '../../components/XPLevel/xpLevel';

const xpImages = require.context('../../../assets/xp');

export default function XPPage() {
  const query = new URLSearchParams(window.location.search);
  const userId = query.get('id');

  const [hasFilters, setHasFilters] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('Acquired');
  const [items, setItems] = useState([]);

  const { getXPs } = useActions(actions);
  const { XPs, level, xpInThisLevel, xpForLevel, totalXp } = useSelector((state) => state.xp);
  const { profile } = useSelector((state) => state.profile);
  const xpPercent = Math.round((xpInThisLevel / xpForLevel) * 100 * 2) / 2;

  useEffect(() => {
    if (userId) getXPs(userId);
    else getXPs(profile._id);
  }, [getXPs]);

  useEffect(() => {
    setItems(XPs.filter(acquiredFilter(selectedFilter)));
    setHasFilters(selectedFilter);
  }, [XPs, selectedFilter]);

  const AchievementItem = ({ xp: { name, description, count } }) => {
    const [isHovered, setIsHovered] = useState(false);
    const xpImage = xpImages('./default.png');
    return (
      <AchievementContainer onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        {isHovered && <TooltipContainer width={250}>{description}</TooltipContainer>}
        <AchievementIcon image={xpImage} acquired={count} />
        <AchievementLabel acquired={count}>{name}</AchievementLabel>
      </AchievementContainer>
    );
  };

  const acquiredFilter = (selectedFilter) => (object) => {
    if (selectedFilter) {
      if (selectedFilter === 'Acquired') {
        return object.count;
      } else {
        return !object.count;
      }
    }
    return true;
  };

  const clearFilters = () => setSelectedFilter('');

  const filterOptions = [
    {
      title: 'Acquired',
      items: ['Acquired', 'Not Acquired'],
      type: 'radio',
      selectedKeyword: selectedFilter,
      getAmount: (item) => XPs.filter((i) => (item === 'Acquired' ? i.count : !i.count)).length,
      onChange: (selection) => {
        setSelectedFilter(selection);
      },
    },
  ];

  return (
    <Wrapper color="transparent">
      <CurvedContainer bottom height={110} image={Images.tanks} />
      <Container column>
        {level && (
          <>
            <Header>XP Level</Header>
            <XPLevel
              width="40%"
              level={level}
              xpPercent={xpPercent}
              xpInThisLevel={xpInThisLevel}
              xpForLevel={xpForLevel}
              totalXp={totalXp}
            />
          </>
        )}
        <Header>XP Earned</Header>
        <ContentContainer>
          <LeftContainer>
            <Filter items={items} hasFilters={hasFilters} clearFilters={clearFilters} options={filterOptions} />
          </LeftContainer>
          <RightContainer>
            <AchievementGrid isXPPage>
              {items.map((xp, index) => (
                <AchievementItem key={xp.name + index} xp={xp} index={index} />
              ))}
            </AchievementGrid>
          </RightContainer>
        </ContentContainer>
      </Container>
    </Wrapper>
  );
}
